const onLoad = () => {
	$('#portfolio-plans__contact-form').submit((e) => {
		e.preventDefault();

		const $form = $(e.target);

		$.post($form.attr('action'), () => {
			$('.portfolio-plans__confirm-message').removeClass('d-none');
			$form.addClass('d-none');
		});
	});

	$('#portfolio-promo-video-modal').on('hide.bs.modal', function (e) {
		// stop youtube video player
		$('#pmt-overview-embed-video').each(function () {
			(this as any).contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
		});
	})
};

$(() => {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad);
});